var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.5C7.63635 16.5 7.05014 16.2524 5.8777 15.7571C2.95923 14.5243 1.5 13.9079 1.5 12.871C1.5 12.5807 1.5 7.54838 1.5 5.25M8.25 16.5V8.5161M8.25 16.5C8.5053 16.5 8.73472 16.4571 9 16.3714M15 5.25V8.625",
    stroke: "#BFBFBF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49444 7.26853L3.30354 6.20839C2.10118 5.62658 1.5 5.33567 1.5 4.875C1.5 4.41433 2.10118 4.12342 3.30354 3.54161L5.49444 2.48146C6.84662 1.82716 7.52273 1.5 8.25 1.5C8.97727 1.5 9.6534 1.82715 11.0056 2.48146L13.1965 3.54161C14.3988 4.12342 15 4.41433 15 4.875C15 5.33567 14.3988 5.62658 13.1965 6.20839L11.0056 7.26853C9.6534 7.92285 8.97727 8.25 8.25 8.25C7.52273 8.25 6.84662 7.92285 5.49444 7.26853Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9L5.25 9.75",
    stroke: "#BFBFBF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3L4.5 6.75",
    stroke: "#BFBFBF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0992 15.1192L16.5 16.5M15.9055 13.1973C15.9055 14.6869 14.6955 15.8946 13.2028 15.8946C11.7101 15.8946 10.5 14.6869 10.5 13.1973C10.5 11.7076 11.7101 10.5 13.2028 10.5C14.6955 10.5 15.9055 11.7076 15.9055 13.1973Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingSearch);
export default __webpack_public_path__ + "static/media/tracking-search.3100fc147eaec06d7e825815e3556701.svg";
export { ForwardRef as ReactComponent };